(function() {
  'use strict';

  function ModalCtrl ($uibModalInstance, Pedido, order) {
    var ctrl = this;
    var maxSize = 200;
    var minSize = 0.1;
    ctrl.zipCode = order.zipCode;
    ctrl.productWeightOpts = ('0.3,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,' +
      '17,18,19,20,21,22,23,24,25,26,27,28,29,30').split(',');
    ctrl.close = function () {
      $uibModalInstance.close();
    };
    ctrl.onSubmit = function (form) {
      if (form.$invalid) { return; }
      ctrl.isLoading = true;
      var productData = {};
      productData.cepDestino = order.zipCode;
      productData.pj = order.userProfile;
      productData.peso = ctrl.productWeight;
      productData.comprimento = parseFloat(ctrl.productLength) === 0 ? minSize : parseFloat(ctrl.productLength);
      productData.largura = parseFloat(ctrl.productWidth) === 0 ? minSize : parseFloat(ctrl.productWidth);
      productData.altura = !ctrl.productHeight || (parseFloat(ctrl.productHeight) === 0) ? minSize : parseFloat(ctrl.productHeight);
      if ((productData.comprimento + productData.largura + productData.altura) > maxSize) {
        ctrl.showError = true;
        return;
      }
      Pedido.obterOpcoesComPreco(productData)
        .then(function(data) {
          ctrl.isLoading = false;
          ctrl.deliveryOpts = data.opcoes;
        })
        .catch(function(err) {
          ctrl.isLoading = false;
          console.log('Price simulator error:', err.statusText);
        });
    };
  }

  angular
    .module('mandaeApp')
    .controller('ModalCtrl', ModalCtrl);

}());
